module.exports = __webpack_public_path__ + "static/media/user.0b84267a.svg";